import { Chart } from '@frontend/chart/types';

export const IOTS_UPTIME_METRIC_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Uptime',
            data: [
                { label: '2026-08-13', value: 96 },
                { label: '2026-08-14', value: 98 },
                { label: '2026-08-15', value: 97 },
                { label: '2026-08-16', value: 94 },
                { label: '2026-08-17', value: 99 },
                { label: '2026-08-18', value: 98 },
                { label: '2026-08-19', value: 97 },
                { label: '2026-08-20', value: 98 }
            ]
        }
    ]
};
